import { Box } from "@chakra-ui/react"
import {
  AppEntityHydrated,
  BlockHeaderEntity,
  PageEntityHydrated,
} from "@jackfruit/common"
import React from "react"
import { useVNZAuthenticationState } from "~/components/cloud-provider/vnz/hooks/useVNZAuthenticationState"
import { useSettings } from "~/hooks/useSettings"
import { useSiteWideBanner } from "~/hooks/useSiteWideBanner"
import HeaderDesktop from "../header/HeaderDesktop"
import HeaderMobile from "../header/HeaderMobile"
import HtmlContent from "../HtmlContent"

const HIDE_IF_LOGGED_IN_WITH_VNZ_MARKER = "HIDE-IF:logged-in-with=vnz"

interface Props {
  config: BlockHeaderEntity
  pages: PageEntityHydrated[]
  appConfig: AppEntityHydrated
}

const HeaderBlock: React.FC<Props> = ({ config, pages, appConfig }) => {
  let { displaySiteWideBanner, siteWideBannerContent } = useSiteWideBanner(
    config,
    appConfig
  )

  let {
    settings: {
      isVNZCloudEnabled,
      displaySiteWideBanner: displayGlobalSiteWideBanner,
      siteWideBannerContent: globalSiteWideBannerContent,
    },
  } = useSettings()

  const {
    state: { isAuthenticated: isAuthenticatedWithVNZ },
  } = useVNZAuthenticationState()

  const shouldHideOnVNZLogin = siteWideBannerContent?.includes(
    HIDE_IF_LOGGED_IN_WITH_VNZ_MARKER
  )

  if (isVNZCloudEnabled && shouldHideOnVNZLogin && isAuthenticatedWithVNZ) {
    displaySiteWideBanner = false
    displayGlobalSiteWideBanner = false
  }

  return (
    <Box>
      <Box display={{ base: "block", lg: "none" }}>
        <HeaderMobile config={config} pages={pages} appConfig={appConfig} />
      </Box>
      <Box display={{ base: "none", lg: "block" }}>
        <HeaderDesktop config={config} pages={pages} appConfig={appConfig} />
      </Box>
      {Boolean(displaySiteWideBanner) && (
        <HtmlContent html={siteWideBannerContent} config={appConfig} />
      )}
      {Boolean(displayGlobalSiteWideBanner) && (
        <HtmlContent html={globalSiteWideBannerContent} config={appConfig} />
      )}
    </Box>
  )
}

export default HeaderBlock
